import React from 'react';
import WebAudioContext from './webAudioContext';
import useWebAudio from './useWebAudio';

interface IProps {
  children: React.ReactNode;
}

const WebAudioProvider = (props: IProps) => {
  const { children } = props;
  const val = useWebAudio();

  return <WebAudioContext.Provider value={val}>{children}</WebAudioContext.Provider>;
};

export default WebAudioProvider;
